import React, { useEffect, useState } from "react";
import {
  Box,
  VStack,
  Heading,
  Flex,
  Divider,
  Button,
  useToast,
  AspectRatio,
} from "@chakra-ui/react";
import * as mod from "../../url";
import axios from "axios";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const LatestVideo = () => {
  const [video, setVideo] = useState([]);
  const toast = useToast();

  const fetchVideos = async () => {
    try {
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/video/latest-video`
      );
      setVideo(data?.data || []);
    } catch (error) {
      toast({
        title: "Error fetching videos",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  return (
    <Box px={{ base: 10, md: 16 }} py={1}>
      <Flex justifyContent="space-between" alignItems="center" mb={3}>
        <Heading as="h2" size="lg" color="yellow.700">
          Latest Videos
        </Heading>
        <Button
          as={Link}
          to="/videos-news"
          size="sm"
          color="yellow.700"
          variant="outline"
        >
          View All
        </Button>
      </Flex>

      <Divider mb={6} />

      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={20}
        slidesPerView={1}
        autoplay={{
          delay: 3000,
          disableOnInteraction: true,
        }}
        breakpoints={{
          440: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1280: { slidesPerView: 5 },
        }}
        style={{ height: "250px" }}
      >
        {video?.map((v) => (
          <SwiperSlide key={v._id}>
            <VStack
              spacing={4}
              borderRadius="md"
              overflow="hidden"
              textAlign="justify"
              //   style={{ border: "1px gray.50" }}
            >
              <AspectRatio w="100%" ratio={16 / 9}>
                <iframe
                  title={v.title?.slice(0, 30)}
                  src={v.videoUrl}
                  allowFullScreen
                />
              </AspectRatio>
              <Box textAlign="justify">
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "goldenrod",
                    padding: "0 5px",
                  }}
                >
                  {v.title?.slice(0, 50)}
                </p>
              </Box>
            </VStack>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default LatestVideo;
